import React from "react";
import Seo from "@/utils/seo";
import Head from "next/head";
import Banner from "@/components/ui/banner";
import ContactUs from "@/components/pages/contact-us/contact-us";
import { getJsonLd } from "@/utils/get-jsonld";
export default function ContactUsPage() {
  const seo = {
    slug: "/contact-us",
  };

  return (
    <>
      <Seo seo={seo} />
      <Head>
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify(getJsonLd({ slug: "contact-us" })),
          }}
        />
      </Head>
      <Banner image="/images/banner1.webp" heading="Contact Us" />
      <ContactUs />
    </>
  );
}
